module.exports = __webpack_public_path__ + "img/icon-message.c1f4f7fc.svg";